
export const commonValidationRules = {
  noRules: [],
  requiredRules: [
    (v) => !!v || 'This field is required'
  ],
  requiredFirstNameRules: [
    (v) => !!v || 'First Name field is required'
  ],
  requiredLastNameRules: [
    (v) => !!v || 'Last Name field is required'
  ],
  minLengthTenChars: [
    (v) => !!v || 'This field is required',
    (v) => (v && v.length >= 10) || 'This field must be at least 10 characters'
  ],
  maxLength64Chars: [
    (v) => !!v || 'This field is required',
    (v) => (v && v.length >= 64) || 'This field must be less then 64 characters'
  ],
  emailIdRules: [
    (v) => !!v || 'E-mail is required',
    (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid'
  ],
  minSelectOneOption: [
    (v) => !!v || 'This field is required',
    (v) => (v && v.length >= 1) || 'Select at least one option'
  ],
  numberRules: [
    v => !!v || "This field is required",
    v => /\d+$/.test(v) || "This field must contain number"
]
};

export default {
  required : (errorMessage) => {
      errorMessage = !!(errorMessage) ? errorMessage : "This field is required.";
      return (value) => {
          return !!(value) ? true : errorMessage;
      };
  },
  duplicateCheck: (valueArr, name) => {
      var duplicateItems = valueArr.filter(function(item) {
        return item == name;
      });
      if (duplicateItems.length) return true;
      return false;
  },
  emailValid: (email) => {
    const expression = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (expression.test(email)) {
      return false;
    }
    return true ;
  },
}